// frontend/src/pages/teacher/CreateCourseModal.js (نسخه نهایی و اصلاح شده)

import React, { useState } from 'react';
import axios from 'axios';
// ✅ افزودن FaPlusCircle و FaChalkboardTeacher و FaBookOpen به لیست ایمپورت‌ها
import { FaSpinner, FaBookOpen, FaChalkboardTeacher, FaPlusCircle } from 'react-icons/fa'; 
import { API_BASE_URL, getAuthHeaders } from '../../modules/api';
import '../../assets/styles/global.css';

const CreateCourseModal = ({ isOpen, onClose, onCourseCreated }) => {
    const [formData, setFormData] = useState({
        title: '',
        grade: '',
    });
    const [uiState, setUiState] = useState({
        isLoading: false,
        error: null,
        success: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUiState(prev => ({ ...prev, isLoading: true, error: null, success: null }));

        const payload = {
            title: formData.title,
            grade: formData.grade,
        };

        try {
            // ✅ ارسال داده به API واقعی ایجاد دوره (core/courses/create/)
            const response = await axios.post(`${API_BASE_URL}/core/courses/create/`, payload, getAuthHeaders());
            
            setUiState(prev => ({ 
                ...prev, 
                success: `دوره "${response.data.title}" با موفقیت ثبت شد.`, 
            }));
            
            onCourseCreated(); 
            
            // ✅ پاک کردن فرم
            setFormData({ title: '', grade: '' }); 
            setTimeout(onClose, 1500); 

        } catch (err) {
            // نمایش خطاهای اعتبارسنجی از بک‌اند
            const errorMsg = err.response?.data?.detail || err.response?.data?.title || err.response?.data?.grade || 'خطا در ایجاد دوره. لطفا ورودی‌ها را بررسی کنید.';
            setUiState(prev => ({ ...prev, error: errorMsg }));
            console.error("Course creation failed:", err.response || err);
        } finally {
            setUiState(prev => ({ ...prev, isLoading: false }));
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    {/* ✅ FaPlusCircle اکنون تعریف شده است */}
                    <h2><FaPlusCircle className="inline-block ml-2" /> ایجاد دوره‌ی جدید</h2> 
                    <button onClick={onClose} className="modal-close-btn">&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {/* نمایش پیام‌های خطا یا موفقیت */}
                        {uiState.error && <div className="alert alert-danger">{uiState.error}</div>}
                        {uiState.success && <div className="alert alert-success">{uiState.success}</div>}
                        
                        {/* عنوان دوره */}
                        <div className="form-group">
                            <label><FaBookOpen /> عنوان دوره</label>
                            <input 
                                type="text" 
                                name="title" 
                                placeholder="مثال: فیزیک دهم - فصل گرما"
                                value={formData.title} 
                                onChange={handleChange} 
                                required
                                disabled={uiState.isLoading || uiState.success} 
                            />
                        </div>

                        {/* پایه تحصیلی */}
                        <div className="form-group">
                            <label><FaChalkboardTeacher /> پایه و رشته</label>
                            <input 
                                type="text" 
                                name="grade" 
                                placeholder="مثال: دهم تجربی"
                                value={formData.grade} 
                                onChange={handleChange} 
                                required
                                disabled={uiState.isLoading || uiState.success}
                            />
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={uiState.isLoading || uiState.success}>
                            انصراف
                        </button>
                        <button 
                            type="submit" 
                            className="button button-primary" 
                            disabled={uiState.isLoading || uiState.success}
                        >
                            {uiState.isLoading ? <FaSpinner className="spinner" /> : 'ثبت دوره'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateCourseModal;